import * as React from 'react';
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { classNames } from 'uitk-react-utils';

export interface PlaceholderCardProps {
  index: number;
  className?: string;
}

export const PlaceholderCard: React.FC<PlaceholderCardProps> = ({ index, className }): JSX.Element => (
  <UitkCardPlaceholder
    className={classNames('all-b-margin-one all-t-margin-two', className)}
    startPhase={index % 2 === 0 ? 'dark' : 'light'}
    data-testid="placeholder-card"
  />
);
